import type { FeatureGateSeed } from './feature-gate-registry';

/**
 * The agentic home and Pulse AI permission modes gates
 * (docs/plans/2026-10-25-feat-pulse-ai-permission-modes-plan.md, D10), spread into
 * FEATURE_GATE_SEEDS in feature-gate-registry.ts at their place in the admin page order.
 */
export const AGENTIC_FEATURE_GATE_SEEDS = {
  agentic_home: {
    label: 'Agentic home',
    shortLabel: 'Home',
    description:
      'Replaces the dashboard with the agentic home: the office’s correspondence, approvals, tasks and Knowledge Library around a Pulse AI chat box, with the person’s Pulse AI work shown as agents. Needs Pulse AI as well. Not a sidebar item - off means the office keeps the current dashboard.',
    group: 'pulse_ai',
  },
  pulse_ai_permission_modes: {
    label: 'Pulse AI permission modes',
    shortLabel: 'Permission modes',
    description:
      'Ask, Auto and Autonomous in the Pulse AI composer, the office cap and the Autonomous switches in Settings, and Apply or Discard for website editor results under Ask. Needs Pulse AI as well. Not a sidebar item - off means the composer keeps Auto, Plan and Ask first.',
    group: 'pulse_ai',
  },
} satisfies Record<string, FeatureGateSeed>;
